import React from 'react'
import { Typography, TextField } from '@mui/material';
import './TextField.scss';

const noop = () => { };

/**
 * @typedef {Object} ReactTextFieldProps
 * @property {Function=} ReactTextFieldProps.changeHandler
 * @property {number=} ReactTextFieldProps.inputLength
 * @property {string} ReactTextFieldProps.valueString
 */

/** @param {import('@mui/material').OutlinedTextFieldProps & ReactTextFieldProps} param0 */
const ReactTextField = ({
    changeHandler = noop,
    fieldClass,
    inputLength = 0,
    label,
    labelClass,
    multiline = false,
    outlinedLabel = false,
    placeholder,
    rows = 0,
    value,
    subHeader,
    subHeaderClass,
    valueString,
    ...other
}) => {
    const textField = (
        <TextField
            {...other}
            label={outlinedLabel ? label : undefined}
            variant="outlined"
            className={outlinedLabel ? fieldClass : [fieldClass, 'text-field-form-fields'].join(' ')}
            placeholder={placeholder}
            onChange={({ target: { value } }) => {
                changeHandler(valueString, value);
            }}
            value={value}
            fullWidth
            multiline={multiline}
            rows={rows}
            margin="normal"
            InputLabelProps={outlinedLabel ? { shrink: true } : { 'aria-label': 'Name' }}
            inputProps={{
                maxLength: inputLength
            }}
        />
    );

    if (outlinedLabel) {
        return textField;
    }

    return (
        <>
            <div className={['text-field-container-labels-full-width', labelClass].join(' ')}>
                <Typography
                    className={[subHeaderClass, 'text-field-sub-header'].join(' ')}
                    color="textSecondary"
                >
                    {label}
                </Typography>
            </div>
            {textField}
        </>
    )
}

export default ReactTextField;